export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7168.4cae4696.jpg";